// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.note[data-v-cb1854ce] {\n  margin-bottom: 16px;\n}\n.note-content[data-v-cb1854ce] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  row-gap: 8px;\n}\n.enable-audio-btn[data-v-cb1854ce] {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n.speaker-select[data-v-cb1854ce] {\n  margin-top: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
